export default __webpack_public_path__ + "static/media/Cpu.ea60e8b8.svg";